import { useState, useCallback } from 'react';

export const useFormState = <T extends Record<string, unknown>>(
  initialState: T,
  clearFieldError?: (field: string) => void
) => {
  const [formValues, setFormValues] = useState<T>(initialState);

  const updateField = useCallback(
    <K extends keyof T>(field: K, value: T[K]) => {
      setFormValues(prev => ({
        ...prev,
        [field]: value,
      }));

      // Clear field error when user starts typing
      if (clearFieldError) {
        clearFieldError(field as string);
      }
    },
    [clearFieldError]
  );

  const updateFields = useCallback((updates: Partial<T>) => {
    setFormValues(prev => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const resetForm = useCallback(() => {
    setFormValues(initialState);
  }, [initialState]);

  return {
    formValues,
    setFormValues,
    updateField,
    updateFields,
    resetForm,
  };
};
